export default "__VITE_PUBLIC_ASSET__3ff9f6aa__"